<template>
  <b-card>
    <div class="section-container">
      <b-row align-v="center">
        <b-col>
          <h5 class="text-uppercase text-info font-weight-bold">
            <i class="fas fa-university mr-1"></i> Academic Information
          </h5>
        </b-col>
      </b-row>

      <b-row class="py-1 align-items-center border-bottom">
        <b-col md="2" sm="6" class="capitalize">Admission Number</b-col>
        <b-col md="4" sm="6">{{ details.admission_no ? details.admission_no : null }}</b-col>

        <b-col md="2" sm="6" class="capitalize">Register Number</b-col>
        <b-col md="4" sm="6">{{ details.register_no ? details.register_no : null }}</b-col>
      </b-row>

      <b-row class="py-1 align-items-center border-bottom">
        <b-col md="2" sm="6" class="capitalize">Date of Joining</b-col>
        <b-col md="4" sm="6">
          {{ details.profile.date_of_joining ? formatDate(details.profile.date_of_joining) : null }}
        </b-col>

        <b-col md="2" sm="6" class="capitalize">Category of Admission</b-col>
        <b-col md="4" sm="6">
          {{ details.profile.category_of_admission ? capitalizeFirstLetter(details.profile.category_of_admission) : null
          }}
        </b-col>
      </b-row>

      <b-row class="py-1 align-items-center border-bottom">
        <b-col md="2" sm="6" class="capitalize">Entrance Rank</b-col>
        <b-col md="4" sm="6">
          {{ details.profile.entrance_rank ? details.profile.entrance_rank : null }}
        </b-col>
      </b-row>

    </div>
  </b-card>
</template>

<script>
export default {
  name: 'UserAcademicInformation',
  props: {
    details: {
      type: Object,
      default: () => []
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('en-GB');
    },
    capitalizeFirstLetter(text) {
      if (!text) return '';
      return text
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
  }
}
</script>
<style scoped>
.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
}

.capitalize {
  text-transform: capitalize;
}
</style>